/* eslint-disable max-len */
// foundation------------------------------
export const FoundationKey = {
  F_QUESTION_1: 'fQuestion1',
  F_QUESTION_2: 'fQuestion2',
  F_QUESTION_3: 'fQuestion3',
  F_QUESTION_4: 'fQuestion4'
};

export const FoundationLabel = {
  F_FOUNDATION_1: 'Reporting Principles',
  F_FOUNDATION_2: 'Using the GRI Standards for sustainability reporting',
  F_FOUNDATION_3: 'Making claims related to the use of the GRI Standards',
  F_QUESTION_1: '',
  F_QUESTION_2: '',
  F_QUESTION_3: '',
  F_QUESTION_4: ''
};

// organizationalProfile------------------------------
export const OrganizationalProfileKey = {
  OP_QUESTION_1: 'opQuestion1',
  OP_QUESTION_2: 'opQuestion2',
  OP_QUESTION_3: 'opQuestion3',
  OP_QUESTION_4: 'opQuestion4',
  OP_QUESTION_5: 'opQuestion5',
  OP_QUESTION_6: 'opQuestion6',
  OP_QUESTION_7: 'opQuestion7',
  OP_QUESTION_8: 'opQuestion8',
  OP_QUESTION_9: 'opQuestion9',
  OP_QUESTION_10: 'opQuestion10',

  OP_QUESTION_11: 'opQuestion11',
  OP_QUESTION_12: 'opQuestion12',
  OP_QUESTION_13: 'opQuestion13',
  OP_QUESTION_14: 'opQuestion14',
  OP_QUESTION_15: 'opQuestion15',
  OP_QUESTION_16: 'opQuestion16',
  OP_QUESTION_17: 'opQuestion17',
  OP_QUESTION_18: 'opQuestion18',
  OP_QUESTION_19: 'opQuestion19',
  OP_QUESTION_20: 'opQuestion20',
  OP_QUESTION_21: 'opQuestion21',
  OP_QUESTION_22: 'opQuestion22',
  OP_QUESTION_23: 'opQuestion23',
  OP_QUESTION_24: 'opQuestion24',
  OP_QUESTION_25: 'opQuestion25',
  OP_QUESTION_26: 'opQuestion26',
  OP_QUESTION_27: 'opQuestion27',
  OP_QUESTION_28: 'opQuestion28'
};

export const OrganizationalProfileLabel = {
  OP_ORGANIZATIONAL_PROFILE_1: 'Organizational details',
  OP_ORGANIZATIONAL_PROFILE_2:
    'Entities included in the organization’s sustainability reporting',
  OP_ORGANIZATIONAL_PROFILE_3: 'Reporting period, frequency and contact point',
  OP_ORGANIZATIONAL_PROFILE_4: 'Restatements of information',
  OP_ORGANIZATIONAL_PROFILE_5: 'External assurance',
  OP_HEADING_1: 'Entity',
  OP_HEADING_2:
    'i. whether the approach involves adjustments to information for minority interests.',
  OP_HEADING_3:
    'ii. How the approach takes into account mergers, acquisitions, and disposal of entities or parts of entities.',
  OP_HEADING_4:
    'iii. Whether and how the approach differs across the disclosures in this Standard and across material topics.',
  OP_HEADING_5:
    'i. Provide a link or reference to the external assurance report(s) or assurance statement(s).',
  OP_HEADING_6:
    'ii. Describe what has been assured and on what basis, including the assurance standards used, the level of assurance obtained, and any limitations of the assurance process.',
  OP_HEADING_7:
    'iii. Describe the relationship between the organization and the assurance provider.',
  OP_HEADING_8: 'i. The reasons for the restatements.',
  OP_HEADING_9: 'ii. The effect of the restatements.',
  OP_QUESTION_1: '',
  OP_QUESTION_2: '',
  OP_QUESTION_3: 'Address line 1',
  OP_QUESTION_4: 'Address line 2',
  OP_QUESTION_5: 'City',
  OP_QUESTION_6: 'State/Province/Region',
  OP_QUESTION_7: 'Zip/Postal code',
  OP_QUESTION_8: 'Country',
  OP_QUESTION_9: '',
  OP_QUESTION_10: '',
  OP_QUESTION_11: '',
  OP_QUESTION_12: '',
  OP_QUESTION_13: '',
  OP_QUESTION_14: '',
  OP_QUESTION_15: 'Reporting period',
  OP_QUESTION_16: 'Frequency',
  OP_QUESTION_17: 'Reporting period',
  OP_QUESTION_18: 'Reason',
  OP_QUESTION_19: '',
  OP_QUESTION_20: 'Name',
  OP_QUESTION_21: 'Designation',
  OP_QUESTION_22: 'E-mail Address',
  OP_QUESTION_23: '',
  OP_QUESTION_24: '',
  OP_QUESTION_25: '',
  OP_QUESTION_26: '',
  OP_QUESTION_27: '',
  OP_QUESTION_28: ''
};

// activitiesAndWorkers----------------------------------
export const ActivitiesAndWorkersKey = {
  AAW_QUESTION_1: 'aawQuestion1',
  AAW_QUESTION_2: 'aawQuestion2',
  AAW_QUESTION_3: 'aawQuestion3',
  AAW_QUESTION_4: 'aawQuestion4',
  AAW_QUESTION_5: 'aawQuestion5',
  AAW_QUESTION_6: 'aawQuestion6',
  AAW_QUESTION_7: 'aawQuestion7',
  AAW_QUESTION_8: 'aawQuestion8',
  AAW_QUESTION_9: 'aawQuestion9',
  AAW_QUESTION_10: 'aawQuestion10',

  AAW_QUESTION_11: 'aawQuestion11',
  AAW_QUESTION_12: 'aawQuestion12',
  AAW_QUESTION_13: 'aawQuestion13',
  AAW_QUESTION_14: 'aawQuestion14',
  AAW_QUESTION_15: 'aawQuestion15',
  AAW_QUESTION_16: 'aawQuestion16',
  AAW_QUESTION_17: 'aawQuestion17',
  AAW_QUESTION_18: 'aawQuestion18',
  AAW_QUESTION_19: 'aawQuestion19',
  AAW_QUESTION_20: 'aawQuestion20',

  AAW_QUESTION_21: 'aawQuestion21',
  AAW_QUESTION_22: 'aawQuestion22',
  AAW_QUESTION_23: 'aawQuestion23',
  AAW_QUESTION_24: 'aawQuestion24',
  AAW_QUESTION_25: 'aawQuestion25',
  AAW_QUESTION_26: 'aawQuestion26',
  AAW_QUESTION_27: 'aawQuestion27',
  AAW_QUESTION_28: 'aawQuestion28',
  AAW_QUESTION_29: 'aawQuestion29',
  AAW_QUESTION_30: 'aawQuestion30',

  AAW_QUESTION_31: 'aawQuestion31',
  AAW_QUESTION_32: 'aawQuestion32',
  AAW_QUESTION_33: 'aawQuestion33',
  AAW_QUESTION_34: 'aawQuestion34',
  AAW_QUESTION_35: 'aawQuestion35',
  AAW_QUESTION_36: 'aawQuestion36',
  AAW_QUESTION_37: 'aawQuestion37',
  AAW_QUESTION_38: 'aawQuestion38',
  AAW_QUESTION_39: 'aawQuestion39',
  AAW_QUESTION_40: 'aawQuestion40',

  AAW_QUESTION_41: 'aawQuestion41',
  AAW_QUESTION_42: 'aawQuestion42',
  AAW_QUESTION_43: 'aawQuestion43',
  AAW_QUESTION_44: 'aawQuestion44',
  AAW_QUESTION_45: 'aawQuestion45',
  AAW_QUESTION_46: 'aawQuestion46',
  AAW_QUESTION_47: 'aawQuestion47',
  AAW_QUESTION_48: 'aawQuestion48',
  AAW_QUESTION_49: 'aawQuestion49',
  AAW_QUESTION_50: 'aawQuestion50'
};

export const ActivitiesAndWorkersLabel = {
  AAW_ACTIVITIES_AND_WORKERS_1:
    'Activities, value chain and other business relationships',
  AAW_ACTIVITIES_AND_WORKERS_2: 'Employees',
  AAW_ACTIVITIES_AND_WORKERS_3: 'Workers who are not employees',
  AAW_HEADING_1: 'Sector',
  AAW_HEADING_2: 'Permanent employees by region -',
  AAW_HEADING_3: 'Temporary employees by region -',
  AAW_HEADING_4: 'Non-guaranteed hours employees by region -',
  AAW_HEADING_5: 'Full-time employees by region -',
  AAW_HEADING_6: 'Part-time employees by region -',
  AAW_HEADING_7:
    'i. The organization’s activities, products, services, and markets served.',
  AAW_HEADING_8: 'ii. The organization’s supply chain.',
  AAW_HEADING_9:
    'iii. The entities downstream from the organization and their activities.',
  AAW_HEADING_10:
    'i. Permanent employees, and a breakdown by gender and by region.',
  AAW_HEADING_11:
    'ii. Temporary employees, and a breakdown by gender and by region.',
  AAW_HEADING_12:
    'iii. Non-guaranteed hours employee, and a breakdown by gender and by region.',
  AAW_HEADING_13:
    'iv. Full-time employee, and a breakdown by gender and by region.',
  AAW_HEADING_14:
    'v. Part-time employee, and a breakdown by gender and by region.',
  AAW_HEADING_15:
    'i. In head count, full-time equivalent (FTE), or using another methodology.',
  AAW_HEADING_16:
    'ii. At the end of the reporting period, as an average across the reporting period, or using another methodology.',
  AAW_HEADING_17: 'By gender :',
  AAW_HEADING_18: 'By region :',
  AAW_HEADING_19:
    'i. The most common types of worker and their contractual relationship with the organization.',
  AAW_HEADING_20: 'ii. The type of work they perform.',
  AAW_HEADING_21:
    'i. In head count, full-time equivalent (FTE), or using another methodology.',
  AAW_HEADING_22:
    'ii. At the end of the reporting period, as an average across the reporting period, or using another methodology.',
  AAW_QUESTION_1: '',
  AAW_QUESTION_2: '',
  AAW_QUESTION_3: '',
  AAW_QUESTION_4: '',
  AAW_QUESTION_5: '',
  AAW_QUESTION_6: '',
  AAW_QUESTION_7: 'Total employees',
  AAW_QUESTION_8: 'Male employees',
  AAW_QUESTION_9: 'Female employees',
  AAW_QUESTION_10: 'Total employees',

  AAW_QUESTION_11: 'Region',
  AAW_QUESTION_12: 'Employee',
  AAW_QUESTION_13: '',
  AAW_QUESTION_14: 'Total Permanent male employees',
  AAW_QUESTION_15: 'Total Permanent female employees',
  AAW_QUESTION_16: 'Region',
  AAW_QUESTION_17: 'Permanent male employee',
  AAW_QUESTION_18: 'Permanent female employee',
  AAW_QUESTION_19: 'Total Temporary male employees',
  AAW_QUESTION_20: 'Total Temporary female employees',
  AAW_QUESTION_21: 'Region',
  AAW_QUESTION_22: 'Temporary male employee',
  AAW_QUESTION_23: 'Temporary female employee',
  AAW_QUESTION_24: 'Total Non-guaranteed hours male employees',
  AAW_QUESTION_25: 'Total Non-guaranteed hours female employees',
  AAW_QUESTION_26: 'Region',
  AAW_QUESTION_27: 'Non-guaranteed hours male employee',
  AAW_QUESTION_28: 'Non-guaranteed hours female employee',
  AAW_QUESTION_29: 'Total Full-time male employees',
  AAW_QUESTION_30: 'Total Full-time female employees',
  AAW_QUESTION_31: 'Region',
  AAW_QUESTION_32: 'Full-time male employee',
  AAW_QUESTION_33: 'Full-time female employee',
  AAW_QUESTION_34: 'Total Part-time male employees',
  AAW_QUESTION_35: 'Total Part-time female employees',
  AAW_QUESTION_36: 'Region',
  AAW_QUESTION_37: 'Part-time male employee',
  AAW_QUESTION_38: 'Part-time female employee',
  AAW_QUESTION_39: '',
  AAW_QUESTION_40: '',

  AAW_QUESTION_41: '',
  AAW_QUESTION_42: '',
  AAW_QUESTION_43:
    'a. Report the total number of workers who are not employees and whose work is controlled by the organization',
  AAW_QUESTION_44: '',
  AAW_QUESTION_45: '',
  AAW_QUESTION_46: '',
  AAW_QUESTION_47: 'Other',
  AAW_QUESTION_48: '',
  AAW_QUESTION_49: '',
  AAW_QUESTION_50: ''
};

// governance----------------------------------
export const GovernanceKey = {
  G_QUESTION_1: 'gQuestion1',
  G_QUESTION_2: 'gQuestion2',
  G_QUESTION_3: 'gQuestion3',
  G_QUESTION_4: 'gQuestion4',
  G_QUESTION_5: 'gQuestion5',
  G_QUESTION_6: 'gQuestion6',
  G_QUESTION_7: 'gQuestion7',
  G_QUESTION_8: 'gQuestion8',
  G_QUESTION_9: 'gQuestion9',
  G_QUESTION_10: 'gQuestion10',

  G_QUESTION_11: 'gQuestion11',
  G_QUESTION_12: 'gQuestion12',
  G_QUESTION_13: 'gQuestion13',
  G_QUESTION_14: 'gQuestion14',
  G_QUESTION_15: 'gQuestion15',
  G_QUESTION_16: 'gQuestion16',
  G_QUESTION_17: 'gQuestion17',
  G_QUESTION_18: 'gQuestion18',
  G_QUESTION_19: 'gQuestion19',
  G_QUESTION_20: 'gQuestion20',

  G_QUESTION_21: 'gQuestion21',
  G_QUESTION_22: 'gQuestion22',
  G_QUESTION_23: 'gQuestion23',
  G_QUESTION_24: 'gQuestion24',
  G_QUESTION_25: 'gQuestion25',
  G_QUESTION_26: 'gQuestion26',
  G_QUESTION_26_1: 'gQuestion26_1',
  G_QUESTION_27: 'gQuestion27',
  G_QUESTION_28: 'gQuestion28',
  G_QUESTION_29: 'gQuestion29',
  G_QUESTION_30: 'gQuestion30',

  G_QUESTION_31: 'gQuestion31',
  G_QUESTION_32: 'gQuestion32',
  G_QUESTION_33: 'gQuestion33',
  G_QUESTION_34: 'gQuestion34',
  G_QUESTION_35: 'gQuestion35',
  G_QUESTION_36: 'gQuestion36',
  G_QUESTION_37: 'gQuestion37',
  G_QUESTION_38: 'gQuestion38',
  G_QUESTION_39: 'gQuestion39',
  G_QUESTION_40: 'gQuestion40',

  G_QUESTION_41: 'gQuestion41',
  G_QUESTION_42: 'gQuestion42',
  G_QUESTION_43: 'gQuestion43',
  G_QUESTION_44: 'gQuestion44',
  G_QUESTION_45: 'gQuestion45',
  G_QUESTION_46: 'gQuestion46',
  G_QUESTION_47: 'gQuestion47',
  G_QUESTION_48: 'gQuestion48',
  G_QUESTION_49: 'gQuestion49',
  G_QUESTION_50: 'gQuestion50',
  G_QUESTION_51: 'gQuestion51',
  G_QUESTION_52: 'gQuestion52'
};

export const GovernanceLabel = {
  G_GOVERNANCE_1: 'Governance structure and composition',
  G_GOVERNANCE_2: 'Nomination and selection of the highest governance body',
  G_GOVERNANCE_3: 'Chair of the highest governance body',
  G_GOVERNANCE_4:
    'Role of the highest governance body in overseeing the management of impacts',
  G_GOVERNANCE_5: 'Delegation of responsibility for managing impacts',
  G_GOVERNANCE_6:
    'Role of the highest governance body in sustainability reporting',
  G_GOVERNANCE_7: 'Conflicts of interest',
  G_GOVERNANCE_8: 'Communication of critical concerns',
  G_GOVERNANCE_9: 'Collective knowledge of the highest governance body',
  G_GOVERNANCE_10:
    'Evaluation of the performance of the highest governance body',
  G_GOVERNANCE_11: 'Remuneration policies',
  G_GOVERNANCE_12: 'Process to determine remuneration',
  G_GOVERNANCE_13: 'Annual total compensation ratio',
  G_HEADING_1: 'Committee',
  G_HEADING_2: 'i. Executive and non-executive members.',
  G_HEADING_3: 'ii. Independence.',
  G_HEADING_4: 'iii. Tenure of members on the governance body.',
  G_HEADING_5:
    'iv. Number of other significant positions and commitments held by each member, and the nature of the commitments.',
  G_HEADING_6: 'v. Gender.',
  G_HEADING_7: 'vi. Under-represented social groups.',
  G_HEADING_8: 'vii. Competencies relevant to the impacts of the organization.',
  G_HEADING_9: 'viii. Stakeholder representation.',
  G_HEADING_10: 'i. Views of stakeholders (including shareholders).',
  G_HEADING_11: 'ii. Diversity.',
  G_HEADING_12: 'iii. Independence.',
  G_HEADING_13: 'iv. Competencies relevant to the impacts of the organization.',
  G_HEADING_14:
    'i. Whether and how the highest governance body engages with stakeholders to support these processes.',
  G_HEADING_15:
    'ii. How the highest governance body considers the outcomes of these processes.',
  G_HEADING_16:
    'i. Whether it has appointed any senior executives with responsibility for the management of impacts.',
  G_HEADING_17:
    'ii. Whether it has delegated responsibility for the management of impacts to other employees.',
  G_HEADING_18: 'i. Cross-board membership.',
  G_HEADING_19: 'ii. Cross-shareholding with suppliers and other stakeholders.',
  G_HEADING_20: 'iii. Existence of controlling shareholders.',
  G_HEADING_21:
    'iv. Related parties, their relationships, transactions, and outstanding balances.',
  G_HEADING_22: 'i. Fixed pay and variable pay.',
  G_HEADING_23: 'ii. Sign-on bonuses or recruitment incentive payments.',
  G_HEADING_24: 'iii. Termination payments.',
  G_HEADING_25: 'iv. Clawbacks.',
  G_HEADING_26: 'v. Retirement benefits.',
  G_HEADING_27:
    'i. Whether independent highest governance body members or an independent remuneration committee oversees the process for determining remuneration',
  G_HEADING_28:
    'ii. How the views of stakeholders (including shareholders) regarding remuneration are sought and taken into consideration',
  G_HEADING_29:
    'iii. Whether remuneration consultants are involved in determining remuneration and, if so, whether they are independent of the organization, its highest governance body and senior executives',
  G_QUESTION_1: '',
  G_QUESTION_2: '',
  G_QUESTION_3: 'Executives',
  G_QUESTION_4: 'Non-Executives',
  G_QUESTION_5: '',
  G_QUESTION_6: '',
  G_QUESTION_7: '',
  G_QUESTION_8: 'Male',
  G_QUESTION_9: 'Female',
  G_QUESTION_10: '',

  G_QUESTION_11: '',
  G_QUESTION_12: '',
  G_QUESTION_13: '',
  G_QUESTION_14: '',
  G_QUESTION_15: '',
  G_QUESTION_16: '',
  G_QUESTION_17: '',
  G_QUESTION_18: '',
  G_QUESTION_19: '',
  G_QUESTION_20: '',

  G_QUESTION_21: '',
  G_QUESTION_22: '',
  G_QUESTION_23: '',
  G_QUESTION_24: '',
  G_QUESTION_25: '',
  G_QUESTION_26: '',
  G_QUESTION_27: '',
  G_QUESTION_28: '',
  G_QUESTION_29: '',
  G_QUESTION_30: '',

  G_QUESTION_31: '',
  G_QUESTION_32: '',
  G_QUESTION_33: '',
  G_QUESTION_34: '',
  G_QUESTION_35: '',
  G_QUESTION_36: '',
  G_QUESTION_37: '',
  G_QUESTION_38: '',
  G_QUESTION_39: '',
  G_QUESTION_40: '',

  G_QUESTION_41: '',
  G_QUESTION_42: '',
  G_QUESTION_43: '',
  G_QUESTION_44: '',
  G_QUESTION_45:
    'Annual total compensation for the organizations highest paid-individual',
  G_QUESTION_46:
    'Median annual total compensation for all of the organizations employees excluding the highest-paid individual',
  G_QUESTION_47:
    'Percentage increase in annual total compensation for the organizations highest-paid individual',
  G_QUESTION_48:
    'Median percentage increase in annual total compensation for all of the organizations employees excluding the highest-paid individual',
  G_QUESTION_49: '',
  G_QUESTION_50: '',
  G_QUESTION_51: '',
  G_QUESTION_52: ''
};

// strategyPoliciesAndPractices----------------------------------
export const StrategyPoliciesAndPracticesKey = {
  SPAP_QUESTION_1: 'spapQuestion1',
  SPAP_QUESTION_2: 'spapQuestion2',
  SPAP_QUESTION_3: 'spapQuestion3',
  SPAP_QUESTION_4: 'spapQuestion4',
  SPAP_QUESTION_5: 'spapQuestion5',
  SPAP_QUESTION_6: 'spapQuestion6',
  SPAP_QUESTION_7: 'spapQuestion7',
  SPAP_QUESTION_8: 'spapQuestion8',
  SPAP_QUESTION_9: 'spapQuestion9',
  SPAP_QUESTION_10: 'spapQuestion10',

  SPAP_QUESTION_11: 'spapQuestion11',
  SPAP_QUESTION_12: 'spapQuestion12',
  SPAP_QUESTION_13: 'spapQuestion13',
  SPAP_QUESTION_14: 'spapQuestion14',
  SPAP_QUESTION_15: 'spapQuestion15',
  SPAP_QUESTION_16: 'spapQuestion16',
  SPAP_QUESTION_17: 'spapQuestion17',
  SPAP_QUESTION_18: 'spapQuestion18',
  SPAP_QUESTION_19: 'spapQuestion19',
  SPAP_QUESTION_20: 'spapQuestion20',

  SPAP_QUESTION_21: 'spapQuestion21',
  SPAP_QUESTION_22: 'spapQuestion22',
  SPAP_QUESTION_23: 'spapQuestion23',
  SPAP_QUESTION_24: 'spapQuestion24',
  SPAP_QUESTION_25: 'spapQuestion25',
  SPAP_QUESTION_26: 'spapQuestion26',
  SPAP_QUESTION_27: 'spapQuestion27',
  SPAP_QUESTION_28: 'spapQuestion28',
  SPAP_QUESTION_29: 'spapQuestion29',
  SPAP_QUESTION_30: 'spapQuestion30'
};

export const StrategyPoliciesAndPracticesLabel = {
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_1:
    'Statement on sustainable development strategy',
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_2: 'Policy commitments',
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_3: 'Embedding policy commitments',
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_4:
    'Processes to remediate negative impacts',
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_5:
    'Mechanisms for seeking advice and raising concerns',
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_6:
    'Compliance with laws and regulations',
  SPAP_STRATEGY_POLICIES_AND_PRACTICES_7: 'Membership associations',
  SPAP_HEADING_1:
    'i. The authoritative intergovernmental instruments that the commitments reference.',
  SPAP_HEADING_2:
    'ii. Whether the commitments stipulate conducting due diligence.',
  SPAP_HEADING_3:
    'iii. Whether the commitments stipulate applying the precautionary principle.',
  SPAP_HEADING_4:
    'iv. Whether the commitments stipulate respecting human rights.',
  SPAP_HEADING_5:
    'i. The internationally recognized human rights that the commitment covers.',
  SPAP_HEADING_6:
    'ii. The categories of stakeholders, including at-risk or vulnerable groups, that the organization gives particular attention to in the commitment.',
  SPAP_HEADING_7:
    'i. How it allocates responsibility to implement the commitments across different levels within the organization.',
  SPAP_HEADING_8:
    'ii. How it integrates the commitments into organizational strategies, operational policies, and operational procedures.',
  SPAP_HEADING_9:
    'iii. How it implements its commitments with and through its business relationships.',
  SPAP_HEADING_10:
    'iv. Training that the organization provides on implementing the commitments.',
  SPAP_HEADING_11: 'i. Instances for which fines were incurred.',
  SPAP_HEADING_12:
    'ii. Instances for which non-monetary sanctions were incurred.',
  SPAP_HEADING_13:
    'i. Fines for instances of non-compliance with laws and regulations that occurred in the current reporting period.',
  SPAP_HEADING_14:
    'ii. Fines for instances of non-compliance with laws and regulations that occurred in previous reporting periods.',
  SPAP_HEADING_15:
    'i. The categories of stakeholders it engages with, and how they are identified.',
  SPAP_HEADING_16: 'ii. The purpose of the stakeholder engagement.',
  SPAP_HEADING_17:
    'iii. How the organization seeks to ensure meaningful engagement with stakeholders.',
  SPAP_QUESTION_1: '',
  SPAP_QUESTION_2: '',
  SPAP_QUESTION_3: '',
  SPAP_QUESTION_4: '',
  SPAP_QUESTION_5: '',
  SPAP_QUESTION_6: '',
  SPAP_QUESTION_7: '',
  SPAP_QUESTION_8: '',
  SPAP_QUESTION_9: '',
  SPAP_QUESTION_10: '',

  SPAP_QUESTION_11: '',
  SPAP_QUESTION_12: '',
  SPAP_QUESTION_13: '',
  SPAP_QUESTION_14: '',
  SPAP_QUESTION_15: '',
  SPAP_QUESTION_16: '',
  SPAP_QUESTION_17: '',
  SPAP_QUESTION_18: '',
  SPAP_QUESTION_19: '',
  SPAP_QUESTION_20: '',

  SPAP_QUESTION_21: '',
  SPAP_QUESTION_22: '',
  SPAP_QUESTION_23: '',
  SPAP_QUESTION_24: '',
  SPAP_QUESTION_25: '',
  SPAP_QUESTION_26: '',
  SPAP_QUESTION_27: '',
  SPAP_QUESTION_28: '',
  SPAP_QUESTION_29: '',
  SPAP_QUESTION_30: ''
};

// stakeholderEngagement----------------------------------
export const StakeholderEngagementKey = {
  SE_QUESTION_1: 'seQuestion1',
  SE_QUESTION_2: 'seQuestion2',
  SE_QUESTION_3: 'seQuestion3',
  SE_QUESTION_4: 'seQuestion4',
  SE_QUESTION_5: 'seQuestion5',
  SE_QUESTION_6: 'seQuestion6',
  SE_QUESTION_7: 'seQuestion7'
};

export const StakeholderEngagementLabel = {
  SE_STAKEHOLDER_ENGAGEMENT_1: 'Approach to stakeholder engagement',
  SE_STAKEHOLDER_ENGAGEMENT_2: 'Collective bargaining agreements',
  SE_QUESTION_1: '',
  SE_QUESTION_2: '',
  SE_QUESTION_3: '',
  SE_QUESTION_4: 'Employees covered by collective bargagaing agreement',
  SE_QUESTION_5: 'Total employees',
  SE_QUESTION_6: '',
  SE_QUESTION_7: ''
};
